<template>
  <section class="">
    <div class="service-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-10">
            <div class="section-heading heading-left">
              <h3 class="title">
                ¿Sabes qué son o para qué sirven las cookies?
              </h3>
            </div>

            <div class="">
              <p>
                Una cookie es un archivo que tiene la finalidad de almacenar datos que podrán ser actualizados
                y recuperados por el sitio web, en este caso RedGirasol.
                <br>
                <br>
                En caso de que nos des tu consentimiento, podremos utilizar cookies que nos permitirán tener más información
                acerca de tus preferencias y personalizar nuestro sitio web conforme a tus intereses individuales.
                Al navegar por RedGirasol podemos tratar tus datos personales. Si quieres saber más sobre nuestra política
                de protección de datos da clic <router-link :to="{name: 'avisoPrivacidad'}">aquí</router-link>.
                <br>
                <br>
                Por otro lado, en la Red, así como en otros portales, siempre podrás decidir si quieres que usemos cookies
                en tus dispositivos o no, salvo en los supuestos en los que las cookies sean necesarias para la navegación por
                nuestro sitio web.
              </p> <br>
            </div>

            <div class="avivon-heading">
              <h3 class="title">
                ¿Qué tipo de cookies utiliza RedGirasol?
              </h3>
            </div>

            <div class="text-justify">
              <p>
                Existen diferentes tipos de cookies dependiendo el objetivo de las mismas, algunas pueden ser para asuntos
                técnicos, de geolocalización, personalización, análisis, publicitarias, entre otras. Su funcionamiento
                dependerá de su duración o de la entidad que las gestione.
                <br>
                <br>
                Estos son algunos ejemplos:
                <br>
                <br>
                <span class="bold">– Cookies de Sesión:</span> Son un tipo de cookies diseñadas para recabar y almacenar datos mientras el usuario
                accede a RedGirasol. Estas cookies no quedan almacenadas en tu dispositivo cuando caduca la sesión o
                cierras el navegador.
                <br>
                <span class="bold">– Cookies Persistentes:</span> En este caso, las cookies almacenarán los datos en tu dispositivo aún y cuando
                cierres tu sesión o el navegador para que sean utilizados cuando te vuelvas a conectar a la Red. Estas
                cookies pueden ser borradas por ti en cualquier momento.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PoliticaCookies"
}
</script>

<style scoped>

</style>